<div class="contenedor-loader-bloqueante">
  <div *ngIf="bloquear" class="block">
    <issys-loader [ngClass]="'i-loader-box'" [mensaje]="mensaje" [label]="bajada"></issys-loader>
  </div>
  <div class="{{bloquear?'blur':'noblur'}}">
    <ng-content></ng-content>
  </div>
</div>